import { useState } from 'react'
import { motion } from 'framer-motion'
import Link from './Link'

const navItems = [
  { name: 'Home', href: '/' },
  { name: 'Capabilities', href: '/#services' },
  { name: 'Products', href: '/#portfolio' },
  { name: 'Company', href: '/#about' },
  { name: 'Contact', href: '/#contact' }
]

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  return (
    <header className="fixed top-0 z-50 w-full border-b border-slate-200/80 bg-white/95 backdrop-blur">
      <div className="container mx-auto px-4">
        <div className="flex h-20 items-center justify-between">
          <Link
            to="/"
            className="flex items-center gap-3"
            ariaLabel="Angel Technology home"
          >
            <img src="/images/brand-mark.svg" alt="Angel Technology" className="h-10 w-10" />
            <span className="hidden text-sm font-semibold uppercase tracking-[0.22em] text-slate-700 sm:block">
              Rehab Solutions
            </span>
          </Link>

          <nav className="hidden items-center gap-8 md:flex">
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className="text-sm font-medium text-slate-600 transition-colors hover:text-slate-950"
              >
                {item.name}
              </Link>
            ))}
            <Link
              to="/#contact"
              className="rounded-md bg-slate-950 px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-teal-700"
            >
              Request Catalog
            </Link>
          </nav>

          <button
            type="button"
            onClick={() => setIsMenuOpen((value) => !value)}
            className="inline-flex h-10 w-10 items-center justify-center rounded-md border border-slate-200 text-slate-700 md:hidden"
            aria-label="Toggle navigation"
          >
            <span className="sr-only">Menu</span>
            <span className="text-xl leading-none">{isMenuOpen ? 'x' : '='}</span>
          </button>
        </div>

        <motion.nav
          initial={false}
          animate={{ height: isMenuOpen ? 'auto' : 0, opacity: isMenuOpen ? 1 : 0 }}
          className="overflow-hidden md:hidden"
        >
          <div className="space-y-2 border-t border-slate-200 py-4">
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className="block w-full rounded-md px-2 py-2 text-left text-sm font-medium text-slate-700 hover:bg-slate-100"
              >
                {item.name}
              </Link>
            ))}
          </div>
        </motion.nav>
      </div>
    </header>
  )
}

export default Header
